import React from 'react';
import { observer } from 'mobx-react';
import { CartCalculationLineItem } from './CartCalculationLineItem';
import { formatPriceDisplay } from 'Util/_HumanWritten/PriceFormattingUtils';
import { isNotNullOrUndefined } from 'Util/TypeGuards';
import { IPriceLineItem } from 'Services/Api/_HumanWritten/PricingService/PricingResult';

export interface DiscountLinesProps {
	discounts: IPriceLineItem[];
	onClearDiscount?: (id: string) => void;
}

function DiscountLines({ discounts, onClearDiscount }: DiscountLinesProps) {
	const groupedDiscounts = Object.values(
		discounts
			.filter(x => x.price !== 0)
			.reduce<Record<string, (typeof discounts)[number]>>((acc, discount) => {
				const key = discount.description ?? 'UNKNOWN'; // Ensure there's always a key
				if (!acc[key]) {
					acc[key] = { ...discount };
				} else {
					acc[key].price += discount.price; // Sum prices of the same discount code
				}
				return acc;
			}, {}),
	);

	return (
		<>
			{groupedDiscounts.map(discount => (
				<CartCalculationLineItem
					keyToUse={discount.id}
					lineItemDisplayName="Discount total"
					lineItemDescription={discount.description ?? ''}
					lineItemPrice={formatPriceDisplay(discount.price, true)}
					className="discount-line-item"
					hasRemovalButton={isNotNullOrUndefined(onClearDiscount)}
					removalOnClick={() => {
						if (isNotNullOrUndefined(onClearDiscount) && isNotNullOrUndefined(discount.id)) {
							return onClearDiscount(discount.id);
						}
						return () => {};
					}}
				/>
			))}
		</>
	);
}

export default observer(DiscountLines);
